import React from 'react';
import ReactSelect from 'react-select';

import Grid from '../layout/grid';

const estilosMenu = {
    menuPortal: base => ({
        ...base,
        zIndex: 99999
    }),
    menu: base => ({
        ...base,
        zIndex: 99999
    })
};

const opcoes = props => (props.options || []).map(item => ({
    value: String(item.id),
    label: item.valor
}));

const propriedadesMenu = () => ({
    styles: estilosMenu,
    menuPosition: 'fixed',
    menuPortalTarget:
        typeof document !== 'undefined' ? document.body : null
});

const valorUnico = props =>
    opcoes(props).find(item =>
        item.value === String(
            props.value !== undefined
                ? props.value
                : props.input && props.input.value
        )
    ) || null;

const valorMultiplo = props => {
    const selecionados = (props.value || []).map(String);

    return opcoes(props).filter(item =>
        selecionados.includes(item.value)
    );
};

export default props => {
    const desabilitado = Boolean(props.readOnly);
    const propriedadesComuns = {
        ...propriedadesMenu(),
        isClearable: true,
        isSearchable: true,
        isDisabled: desabilitado,
        options: opcoes(props)
    };

    return (
        <Grid
            cols={props.cols}
            style={{
                minWidth: props.minWidth,
                maxWidth: props.maxWidth,
                paddingBottom: props.paddingBottom,
                marginBottom: props.marginBottom
            }}
        >
            <div
                className='form-group'
                style={{
                    paddingBottom: props.paddingBottom,
                    marginBottom: props.marginBottom
                }}
            >
                {props.label &&
                    <label htmlFor={props.name}>
                        {props.label}
                    </label>}

                {props.multiple
                    ? <ReactSelect
                        {...propriedadesComuns}
                        isMulti
                        value={valorMultiplo(props)}
                        onChange={item => props.onChange(item)}
                    />
                    : props.onChange
                        ? <ReactSelect
                            {...propriedadesComuns}
                            value={valorUnico(props)}
                            placeholder={
                                valorUnico(props)
                                    ? valorUnico(props).label
                                    : 'Selecione'
                            }
                            onChange={item =>
                                props.onChange(
                                    item ? item.value : null
                                )}
                        />
                        : <ReactSelect
                            {...propriedadesComuns}
                            value={valorUnico(props)}
                            onChange={item =>
                                props.input.onChange(
                                    item ? item.value : null
                                )}
                            onBlur={() => props.input.onBlur()}
                        />}
            </div>
        </Grid>
    );
};
